export default "__VITE_ASSET__CG_gS5aB__"